import { EQueryOperator } from "../Enums/EQueryOperator.enum";
import { Utilidades } from "../helper/utilidades";

export class FilterGrid {
  public field: string;
  public operator: string;
  public value: any;

  constructor(filter: string[]) {
    this.field = filter[0];
    this.operator = filter[1];
    this.value = filter[2];
  }

  public static isFilterGrid(value: any): boolean {
    return Utilidades.isOfType<FilterGrid>(value, "field");
  }

  public getEndPointOperator(): EQueryOperator {
    switch (this.operator.trim()) {
      case "=": {
        return EQueryOperator.Equal;
      }
      case "<>": {
        return EQueryOperator.NotEqual;
      }
      case ">": {
        return EQueryOperator.GreaterThan;
      }
      case ">=": {
        return EQueryOperator.GreaterThanOrEqual;
      }
      case "<": {
        return EQueryOperator.LessThan;
      }
      case "<=": {
        return EQueryOperator.LessThanOrEqual;
      }
      case "contains": {
        return EQueryOperator.Contains;
      }
      default:
        throw Error(`operador ${this.operator} no contemplado`);
    }
  }

  public toString(): string {
    if (this.getEndPointOperator() === EQueryOperator.Contains)
      return `${this.getEndPointOperator()}(${this.field}, '${this.value}') eq true`;

    return `${this.field} ${this.getEndPointOperator()} ${this.getValue()}`;
  }

  private getValue(): string {

    if(Utilidades.stringIsNumber(this.value))
     return this.value;

    if (Utilidades.isDate(this.value)) {
      let fecha = new Date(this.value);
      return Utilidades.toISOFormatDate(fecha);
    }

    if (Utilidades.isString(this.value))
      return `'${this.value}'`;

    return this.value;
  }
}
